import { useMemo } from 'react';
import type { AppliedFilters } from '~/contracts/common';
import useGetRecommendedVehicles from '~/hooks/home/useGetRecommendedVehicles';
import useGetMostViewedOrMostRecentYMM from './useGetMostViewedOrMostRecentYMM';

export default function useGetUpgradeYourRideVehicles() {
  const { vehicleId, price = 0 } = useGetMostViewedOrMostRecentYMM() ?? {};
  const filters = useMemo<Partial<AppliedFilters>>(
    () => ({
      price: {
        min: Math.floor(price * 1.1) // Find slightly more expensive vehicle
      }
    }),
    [price]
  );

  return useGetRecommendedVehicles(12, filters, vehicleId);
}
